import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import QPTrackingCriteria from "./QPTrackingCriteria";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { ReportCategory } from "../ReportCategory";

@NeoReport("QPTrackingReport",{ category: ReportCategory.CombinedReports })
export default class QPTrackingReport extends Report<QPTrackingCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(QPTrackingCriteria);
    }

    public renderCriteria() {
        return <DateSelectionComponent criteria={this.criteria} />;
    }
}